import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import { Check, X } from "phosphor-react";
import { fget, fpatch } from "../../../API/callsAPI";
import notificationSettingsStyles from "./NotificationSettingsStyles";

const NotificationSettingsOverview = ({ setSnackValue, projectId }) => {
  const classes = notificationSettingsStyles();
  const [showButtons, setShowButtons] = useState(false);
  const [notificationEvents, setnotificationEvents] = useState([]);
  const [value, setValue] = useState("");
  const [check, setCheck] = useState([]);
  const [allNotifications, setAllNotifications] = useState([]);
  const [backupNotifications, setBackupNotifications] = useState([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  function transformNotification(notificationArr) {
    const result = [];
    const modal_type = [];

    for (const eachNotification of notificationArr) {
      if (!modal_type.includes(eachNotification.content_type)) {
        const values = notificationArr.filter(
          (obj) => obj.content_type === eachNotification.content_type
        );
        result.push({ name: eachNotification.content_type, values });
        modal_type.push(eachNotification.content_type);
      }
    }

    return result;
  }

  const fetchNotificationEvents = async () => {
    try {
      const res = await fget({
        url: `notification-types/${projectId}/`,
      });
      const eventsObj = {};
      res.data.results.forEach((eachNotification) => {
        eventsObj[eachNotification.event_type] = eachNotification.is_active;
      });
      setAllNotifications(res.data.results);
      setBackupNotifications(res.data.results);
      const transformedNotification = transformNotification(res.data.results);
      setnotificationEvents(transformedNotification);
      setCheck(eventsObj);

      const filteredEvent = res.data.results.filter(
        (eachEvent) => eachEvent.is_active === false
      );
      filteredEvent.length > 0 ? setValue("2") : setValue("1");
    } catch (error) {
      console.log(error);
    }
  };

  const changeEmailConfiguration = async () => {
    const eventObj = {};
    if (value === "1") {
      allNotifications.map((eachNotification) => {
        eventObj[eachNotification.event_type] = true;
      });
    } else if (value === "2") {
      allNotifications.map((eachNotification) => {
        if (check[eachNotification.event_type] !== eachNotification.is_active) {
          eventObj[eachNotification.event_type] =
            check[eachNotification.event_type];
        }
      });
    }
    try {
      const res = await fpatch({
        url: `configure-notifications/`,
        data: {
          project: projectId,
          events: allNotifications,
        },
      });
      if (res.status === 200 || 201) {
        setSnackValue({
          isOpen: true,
          message: "Changes Saved Successfully",
          isError: false,
        });
        fetchNotificationEvents();
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  const discardChanges = () => {
    setAllNotifications(backupNotifications);
  };

  const handleSwitchToggle = (id) => {
    setAllNotifications((prevNotifications) =>
      prevNotifications.map((notification) =>
        notification.id === id
          ? { ...notification, is_active: !notification.is_active }
          : notification
      )
    );
  };

  const handleCheckboxToggle = (id, field) => {
    setAllNotifications((prevNotifications) =>
      prevNotifications.map((notification) =>
        notification.id === id
          ? { ...notification, [field]: !notification[field] }
          : notification
      )
    );
  };

  useEffect(() => {
    fetchNotificationEvents();
  }, []);

  // Compare allNotifications and backupNotifications to enable/disable Save button
  useEffect(() => {
    const isEqual =
      JSON.stringify(allNotifications) === JSON.stringify(backupNotifications);
    setIsSaveDisabled(isEqual);
  }, [allNotifications, backupNotifications]);

  return (
    <div>
      <div className={classes.flexBetween}>
        <span style={{ fontSize: "20px", fontWeight: 600 }}>Notifications</span>
        <div className={classes.notificationToolbarButtons}>
          <Button
            startIcon={<Check />}
            variant="contained"
            className={classes.saveButton}
            onClick={changeEmailConfiguration}
            disabled={isSaveDisabled} // Disable based on state
          >
            Save Changes
          </Button>
          <Button startIcon={<X />} variant="outlined" onClick={discardChanges}>
            Discard Changes
          </Button>
        </div>
      </div>
      <TableContainer className={classes.sequenceTableContainer}>
        <Table aria-label="simple table" className={classes.table}>
          <TableHead className={classes.tableHeader}>
            <TableRow className={classes.tableRow}>
              <TableCell className={classes.headTableTwo} align="left">
                Notifications Type
              </TableCell>
              <TableCell className={classes.headTable} align="center">
                In-App notification
              </TableCell>
              <TableCell className={classes.headTable} align="center">
                Push notification
              </TableCell>
              <TableCell className={classes.headTable} align="center">
                Email notification
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            className={classes.tableBody}
            style={{ height: `calc(100vh - 290px)` }}
          >
            {allNotifications.map((notification) => (
              <TableRow
                hover
                key={notification.id}
                className={classes.tableRow}
              >
                <TableCell
                  component="th"
                  scope="row"
                  className={classes.listTextTwo}
                  align="left"
                >
                  <div className={classes.switchAndType}>
                    <Switch
                      checked={notification.is_active}
                      onChange={() => handleSwitchToggle(notification.id)}
                    />
                    <div style={{ marginTop: "6px" }}>
                      <span style={{ fontSize: "18px", fontWeight: 500 }}>
                        {notification.plain_text}
                      </span>
                      <p style={{ color: "gray", margin: "6px 0px" }}>--</p>
                    </div>
                  </div>
                </TableCell>
                <TableCell className={classes.listText} align="center">
                  <Tooltip title="In App Notification">
                    <Checkbox
                      checked={notification.in_app_enabled}
                      onChange={() =>
                        handleCheckboxToggle(notification.id, "in_app_enabled")
                      }
                      disabled={!notification.is_active}
                    />
                  </Tooltip>
                </TableCell>
                <TableCell className={classes.listText} align="center">
                  <Tooltip title="Push Notification">
                    <Checkbox
                      checked={notification.push_notif_enabled}
                      onChange={() =>
                        handleCheckboxToggle(
                          notification.id,
                          "push_notif_enabled"
                        )
                      }
                      disabled={!notification.is_active}
                    />
                  </Tooltip>
                </TableCell>
                <TableCell className={classes.listText} align="center">
                  <Tooltip title="Email Notification">
                    <Checkbox
                      checked={notification.email_enabled}
                      onChange={() =>
                        handleCheckboxToggle(notification.id, "email_enabled")
                      }
                      disabled={!notification.is_active}
                    />
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default NotificationSettingsOverview;
